import {ICommonGallery} from "../interfaces";

interface ICommonGalleryProps {
    commonGalleryProps: ICommonGallery,
}
/**
 * the entry point
 */
const ProductCustomGalleryTitle = (props: ICommonGalleryProps) => {

    const commonGalleryProps = props.commonGalleryProps;

    return (

            <>
                    <div className={"flex flex-col justify-center p-4 " + commonGalleryProps?.dataCustomTitleCss ?? 'items-center'  }>
                        {commonGalleryProps?.dataCustomTitle && <div className="waves-h2 pb-0 text-center">
                            {commonGalleryProps?.dataCustomTitle}
                        </div>}
                        {commonGalleryProps?.dataCustomSubTitle && <div className="text-base lg:text-lg pt-2 pb-8 text-center">
                            {commonGalleryProps?.dataCustomSubTitle}
                        </div>}
                    </div>
            </>
    )
};

export default ProductCustomGalleryTitle;